<template>
  <div class="d-none d-sm-flex col-auto col-md-3 col-xl-2 px-sm-2 px-0 bg-side-bar">
    <div class="d-flex flex-column align-items-center align-items-sm-start px-3 pt-2 text-white min-vh-100">
      <a
        href="/"
        class="d-flex align-items-center pb-3 mb-md-0 me-md-auto text-white text-decoration-none"
      >
        <span class="fs-6 d-none d-sm-inline fw-bold">Menu</span>
      </a>
      <ul
        class="nav nav-pills flex-column mb-sm-auto mb-0 align-items-center align-items-sm-start"
        id="menu"
      >
        <li>
          <router-link
            to="/superadmin-dashboard/users"
            class="nav-link px-0 align-middle"
            active-class="active"
          >
            <i class="fs-6 bi-table"></i>
            <span class="ms-1 d-none d-sm-inline">Users ({{ userCount !== null && userCount !== undefined ? userCount : "x" }})</span>
          </router-link>
        </li>
        <li>
          <router-link
            to="/superadmin-dashboard/requests"
            class="nav-link px-0 align-middle"
            active-class="active"
          >
            <i class="fs-6 bi-table"></i>
            <span class="ms-1 d-none d-sm-inline">Requests ({{ requestCount !== null && requestCount !== undefined ? requestCount : "x" }})</span>
          </router-link>
        </li>

        <li>
          <router-link
            to="/superadmin-dashboard/leagues"
            class="nav-link px-0 align-middle"
            active-class="active"
          >
            <i class="fs-6 bi-table"></i>
            <span class="ms-1 d-none d-sm-inline">Leagues ({{ leagueCount !== null && leagueCount !== undefined ? leagueCount : "x" }})</span>
          </router-link>
        </li>
        <li class="w-100">
          <router-link
            to="/superadmin-dashboard/clubs"
            class="nav-link px-0"
            active-class="active"
          >
            <span class="d-none d-sm-inline">Clubs ({{ clubCount !== null && clubCount !== undefined ? clubCount : "x" }})</span>
          </router-link>
        </li>
        <li class="w-100">
          <router-link
            to="/superadmin-dashboard/teams"
            class="nav-link px-0"
            active-class="active"
          >
            <span class="d-none d-sm-inline">Teams ({{ teamCount !== null && teamCount !== undefined ? teamCount : "x" }})</span>
          </router-link>
        </li>

        <li>
          <router-link
            to="/superadmin-dashboard/members"
            class="nav-link px-0"
            active-class="active"
          >
            <span class="d-none d-sm-inline">Staff Members ({{ memberCount !== null && memberCount !== undefined ? memberCount : "x" }})</span>
          </router-link>
        </li>
        <li>
          <router-link
            to="/superadmin-dashboard/events"
            class="nav-link px-0"
            active-class="active"
          >
            <span class="d-none d-sm-inline">Events ({{ eventCount !== null && eventCount !== undefined ? eventCount : "x" }})</span>
          </router-link>
        </li>

        <li>
          <router-link
            to="/superadmin-dashboard/emailjs"
            class="nav-link px-0 align-middle"
            active-class="active"
          >
            <i class="fs-4 bi-table"></i>
            <span class="ms-1 d-none d-sm-inline">EmailJS</span>
          </router-link>
        </li>
      </ul>
      <hr />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    userCount: Number, // Receive user count as a prop
    leagueCount: Number, // Receive league count as a prop
    clubCount: Number,
    teamCount: Number,
    memberCount: Number,
    eventCount: Number,
    playerCount: Number,
    requestCount: Number,
  },
};
</script>

<style scoped lang="scss">
$dark-blue: #0d325f;
$menu-link: #87c5ed;
$menu-link-hover: #fff;

.bg-side-bar {
  background-color: $dark-blue;
  transition: all ease-in-out 0.5s;

  a {
    color: $menu-link;
    text-shadow: 1px 1px #111;

    &:hover {
      color: $menu-link-hover;
    }
    &.active {
      background-color: transparent;
    }
  }
}
</style>
